module.exports = __webpack_public_path__ + "static/media/47.1eddb74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/47.jpg
// module id = 608
// module chunks = 0